import { values } from 'lodash';
import Program from 'utils/program';
import { programs } from './constants';

export const PATIENT_SUMMARY = '/patient-summary';
export const INVALID_PATH = '/404.html';
export const MFA_PATH = '/mfa';
const DOCUMENTS = '/documents';

export const documentDashboardRoutes = {
  DOCUMENTS_DASHBOARD: `${DOCUMENTS}/dashboard`,
  DOCUMENTS_LESSON_CONTENT: `${DOCUMENTS}/lesson-content`,
  DOCUMENTS_LESSON_SUMMARIES: `${DOCUMENTS}/lesson-summaries`,
};

// application routes
export const routes: Readonly<{ [key: string]: string }> = {
  MFA_REGISTER: `${MFA_PATH}/register`,
  MFA_VALIDATION: `${MFA_PATH}/validation`,
  ROOT: '/',
  // Role Management
  MANAGE_LOCATIONS: '/manage-locations',
  MANAGE_CLINICIANS: '/manage-clinicians',
  MANAGE_PATIENTS: '/manage-patients',
  MANAGE_PATIENT_ADHERENCE: '/patient-adherence',
  // Summaries, Dashboards and other resources
  DOCUMENTS,
  ...documentDashboardRoutes,
  PATIENT_SUMMARY,
  SOMRYST_DASHBOARD: `${PATIENT_SUMMARY}/somryst-dashboard`,
  PATIENT_DASHBOARD_IFRAME: '/patient-dashboard',
  // Account & Login Items
  LOG_IN: '/login',
  CLINICIAN_SETUP_ACCOUNT: '/clinician/setup-account',
  SETUP_ACCOUNT: '/setup-account',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  // Footer items
  LEGAL: '/legal',
  PRIVACY_POLICY: '/legal/privacy',
  SUPPORT: '/legal/support',
  TERMS_OF_SERVICE: '/legal/terms',
  // ERROR ITEMS
  INVALID_PATH,
  MAINTENANCE: '/503.html',
  WHOOPS: '/whoops',
  RESET_DFU: '/reset/dfu',
  RESET_PATIENT_PRIVACY: '/reSET/legal/privacy',
  RESET_PATIENT_TERMS: '/reSET/legal/terms',
  RESET_O_DFU: '/reset-o/dfu',
  RESET_O_PATIENT_PRIVACY: '/reSET-O/legal/privacy',
  RESET_O_PATIENT_TERMS: '/reSET-O/legal/terms',
  RESET_0_DFU: '/reset-0/dfu',
};

export const isResetProgram = (): boolean =>
  Program.get()?.name === programs.RESET;
export const isPear002aProgram = (): boolean =>
  Program.get()?.name === programs.PEAR002A;

export const isSupportedProgram = (program: string) =>
  Object.values(programs).includes(program);

export const isValidPath = (path: string): boolean => {
  const parsedURI = path.split('?')[0];
  const isValid = values(routes).some(
    (route) => parsedURI.toLowerCase() === route.toLowerCase(),
  );
  return isValid;
};

export const isReportedTrackingUrl = (pathName: string): boolean =>
  ![
    routes.ROOT,
    routes.LOG_IN,
    routes.FORGOT_PASSWORD,
    routes.RESET_PASSWORD,
    routes.TERMS_OF_SERVICE,
    routes.PRIVACY_POLICY,
    routes.SUPPORT,
    routes.INVALID_PATH,
    routes.MFA_REGISTER,
    routes.MFA_VALIDATION,
  ].includes(pathName);
